import {
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
  TableHeader,
  Typography,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  Table,
} from '@ui/components';
import { VehicleCategory } from '@interfaces/models';
import React, { FC } from 'react';
import { t } from 'i18next';

interface EditVehicleDialogProps {
  children: React.ReactNode;
}

export const VehicleCategoryTipDialog: FC<EditVehicleDialogProps> = (props) => {
  const { children } = props;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="overflow-auto">
        <DialogHeader>
          <DialogTitle>
            <Typography variant="h300">
              {t('ONBOARDING.ADD_VEHICLES.VEHICLES_CATEGORY_TIP_TITLE')}
            </Typography>
          </DialogTitle>
        </DialogHeader>
        <Table className="table-fixed">
          <TableHeader>
            <TableRow>
              <TableHead>
                {t('ONBOARDING.ADD_VEHICLES.VEHICLES_CATEGORY_TIP_COLUMN_TITLE')}
              </TableHead>
              <TableHead>
                {t('ONBOARDING.ADD_VEHICLES.VEHICLES_CATEGORY_TIP_COLUMN_DESCRIPTION')}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {/* TODO: we should not destruct enums here */}
            {Object.values(VehicleCategory).map((value) => (
              <TableRow key={value}>
                <TableCell>{t(`VEHICLE_CATEGORY.${value.toUpperCase()}`)}</TableCell>
                <TableCell>{t(`VEHICLE_CATEGORY.${value.toUpperCase()}_DESCRIPTION`)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
